<template>
  <div :class="isFold ? 'side-bar' : 'side-bar fold'">
    <div class="side-bar-fold">
      <span v-if="isFold">{{leftMenuTitle}}</span>
      <i
        :class="isFold ? 'iconfont icon-menu-close fold-line':'iconfont icon-menu-open fold-line'"
        @click="clickFold"
      ></i>
    </div>
    <div class="menu-line"></div>
    <el-menu
      :default-active="activeMenu"
      :collapse="!isFold"
      :unique-opened="true"
      class="side-menu"
    >
      <template v-for="(menu, i) in leftMenuData">
        <el-submenu
          v-if="menu.children && menu.children.length"
          :index="'/'+menu.name"
          :key="menu.code"
        >
          <template slot="title">
            <i :class="'iconfont '+menu.icon"></i>
            <span slot="title">{{ menu.label }}</span>
          </template>
          <el-menu-item
            v-for="(child, j) in menu.children"
            :index="'/'+menu.name+'/'+child.name"
            :key="child.code"
            @click="jumpRouter('/'+menu.name+'/'+child.name,i+'-'+j,child.code)"
            :id="i+'-'+j"
          >
            <i class="item-icon"></i>
            <span>{{ child.label }}</span>
          </el-menu-item>
        </el-submenu>
        <el-menu-item
          v-else
          :index="'/'+menu.name"
          :id="i+'-'+i"
          :key="menu.code"
          @click="jumpRouter('/'+menu.name,i+'-'+i,menu.code)"
        >
          <template>
            <i :class="'iconfont '+menu.icon"></i>
            <span slot="title">{{ menu.label }}</span>
          </template>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>
<script>
// import { bamApi } from "@control/services";
import { mapState } from "vuex";
import { utils } from "@/utils/utils";
export default {
  data() {
    return {
      isFold: true,
      // defaultActive: "",
      // localStorageLeftMenuTitle: "",
      menuData: []
    };
  },
  computed: {
    leftMenuData: function() {
      return this.$store.state.main.leftMenuData;
    },
    leftMenuTitle: function() {
      return this.$store.state.main.menuTitle;
    },
    ...mapState({
      userInfo: state => state.main.userInfo
    }),
    activeMenu() {
      const { meta, path } = this.$route;
      // 主账号,子账号跳转到欢迎页
      let isMainLogin = utils.getCookie('_need_main_username_')
      return isMainLogin !== 'true' && path == "/"
        ? "/user-center/account/base-info"
        : meta.parent || path;
      // return path == "/" ? "":meta.parent || path;
    },
  },
  created() {},
  watch: {},
  mounted() {
    // this.localStorageLeftMenuTitle = localStorage.getItem("leftMenuTitle");
  },
  methods: {
    clickFold() {
      if (this.isFold) {
        this.isFold = false;
      } else {
        this.isFold = true;
      }
      this.$emit("fold", this.isFold);
    },
    async jumpRouter(path, select, code) {
      // await localStorage.setItem("currentMenuCode", code);
      this.$router.push(path);
    }
  }
};
</script>

<style lang="scss" scoped>
.side-bar {
  width: 220px;
  box-shadow: 1px 0px 4px 0px rgba(33, 76, 217, 0.17);
  background: #ffffff;
  vertical-align: top;
  color: #1e2b4d;
  float: left;
  padding-bottom: 9999vh;
  margin-bottom: -9999vh;
  position: relative;
  z-index: 2;
  .side-bar-fold {
    height: 60px;
    margin: 0 24px;
    line-height: 60px;
    font-weight: bold;
    .fold-line {
      font-weight: normal;
      vertical-align: bottom;
      cursor: pointer;
      float: right;
    }
  }
  .menu-line {
    height: 1px;
    background: #e6eaf5;
    margin: 0 24px;
    margin-bottom: 10px;
  }
  .side-menu {
    margin-bottom: 10px;
    .iconfont {
      margin-right: 16px;
    }
  }
}

.side-bar.fold {
  width: 48px;
  transition: all 0.1s ease, 0.1s ease;
  .fold-line {
    position: absolute;
    left: 17px;
  }
  .menu-line {
    margin: 0 8px;
    margin-bottom: 10px;
  }
  .side-menu {
    .iconfont {
      margin-left: -8px;
      transition: all 0.1s ease, 0.1s ease;
    }
  }
}
</style>
<style lang="scss">
/*el-cover*/
.side-bar,
.side-bar.fold {
  .el-menu--collapse {
    width: 48px;
  }
}

.side-bar.fold {
  .el-submenu.is-active .el-submenu__title {
    background-color: #ecf3ff;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/main/view/layout/SideBar.vue